





































































































































import Vue from 'vue'
import { mapState } from 'vuex'

import TagBrowser from '@/components/tag-browser/index.vue'
import { VueContext } from 'vue-context'

import { FindItem, CreateItem, PatchItem, DeleteItem } from '@/api/data-logger'

import { Item } from '@/types/data-log'

export default Vue.extend({
  components: {
    TagBrowser,
    VueContext,
  },
  props: {
    datalogId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      items: [] as Item[],
      indexOfSelected: -1,
      selectedId: -1,
      newItem: {} as Item,
    }
  },

  computed: {
    ...mapState('tag', { tags: 'items' }),
    showNewRow(): boolean {
      return this.datalogId !== -1
    },
  },

  methods: {
    // ---------------------------------------------------------------------------------------------------------------------------
    // Database operation
    // ---------------------------------------------------------------------------------------------------------------------------
    async find() {
      this.items = await FindItem({ datalogId: this.datalogId } as Item)
    },
    async create(item: Item) {
      await CreateItem(item)
    },

    async patch(id: number, item: Item) {
      await PatchItem(id, item)
    },

    async delete(id: number) {
      await DeleteItem(id)
    },

    // ------------------------------------------------------------------------------------------------------------------------------
    //
    // ------------------------------------------------------------------------------------------------------------------------------

    /**
     * Inisialisasi variabel newItem
     */
    initializeNewItem() {
      this.newItem = {
        datalogId: this.datalogId,
        name: '',
        tagUID: '',
      }
    },

    // ---------------------------------------------------------------------------------
    // Mouse & keyboard events
    // ---------------------------------------------------------------------------------
    onRowClicked(id: number) {
      this.selectedId = id
    },

    async onRowEnterKeyup(id: number, item: Item) {
      await this.patch(id, item)
      await this.find()
    },

    async onNewDataEnterKeyUp() {
      await this.create(this.newItem)
      this.initializeNewItem()
      await this.find()
    },

    onRightMouseClicked($event: MouseEvent, id: number) {
      this.selectedId = id
      // eslint-disable-next-line
      ;(this as any).$refs.menu.open($event)
    },

    // ---------------------------------------------------------------------------------
    // Context menu
    // ---------------------------------------------------------------------------------
    async onContextMenuDelete() {
      // eslint-disable-next-line
      ;(this as any).$refs.dialogDelete.show()
    },
    async onContextMenuRefresh() {
      await this.find()
    },

    // ---------------------------------------------------------------------------------
    // Dialog action
    // ---------------------------------------------------------------------------------
    async onDialogDeleteOk() {
      await this.delete(this.selectedId)
      await this.find()
    },
  },

  watch: {
    datalogId: async function(val: number) {
      this.items = []
      this.newItem.datalogId = val
      this.selectedId = -1
      if (val == -1) return
      await this.find()
    },
  },

  created() {
    this.initializeNewItem()
  },
})
